export const UPDATE_OPTIONS = 'UPDATE_OPTIONS';
export const UPDATE_VIEW_TYPE = 'UPDATE_VIEW_TYPE';
export const UPDATE_DATE_TYPE = 'UPDATE_DATE_TYPE';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
